import {
  createUnifiedTheme,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';

const sharedNavigation = {
  background: '#1E1B4B',
  indicator: '#E8436E',
  color: '#ffffffb3',
  selectedColor: '#ffffff',
  navItem: {
    hoverBackground: '#2D2975',
  },
};

const sharedPageThemes = {
  home: genPageTheme({
    colors: ['#1E1B4B', '#E8436E'],
    shape: shapes.wave,
  }),
  documentation: genPageTheme({
    colors: ['#1E1B4B', '#3B3486'],
    shape: shapes.wave2,
  }),
  tool: genPageTheme({
    colors: ['#3B3486', '#E8436E'],
    shape: shapes.round,
  }),
  other: genPageTheme({
    colors: ['#1E1B4B', '#E8436E'],
    shape: shapes.wave,
  }),
};

export const saltSquareDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: {
      main: '#FF7B93',
    },
    secondary: {
      main: '#3B3486',
    },
    navigation: sharedNavigation,
  },
  defaultPageTheme: 'home',
  pageTheme: sharedPageThemes,
});

export const saltSquareLightTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: '#E8436E',
    },
    secondary: {
      main: '#3B3486',
    },
    navigation: sharedNavigation,
  },
  defaultPageTheme: 'home',
  pageTheme: sharedPageThemes,
});
